import React from 'react';
import { Form, Row, Col, InputNumber, DatePicker, Select, Button, Input } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Option } = Select;

const InvoiceVouchers = ({ currencies, form }) => {
  return (
    <div style={{ minHeight: '15vh', maxHeight: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
      <Row
        gutter={[2, 2]}
        style={{
          fontWeight: 'bold',
          marginBottom: 2,
          borderBottom: '1px solid #d9d9d9',
          paddingBottom: 1,
        }}
      >
        <Col xs={4}>القيمة</Col>
        <Col xs={5}>التاريخ</Col>
        <Col xs={4}>العملة</Col>
        <Col xs={7}>ملاحظات</Col>
        <Col xs={4}>إجراءات</Col>
      </Row>
      <Form.List name="Vouchers">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => {
              // Check if this voucher has an Id (existing voucher)
              const voucherId = form ? form.getFieldValue(['Vouchers', name, 'Id']) : null;
              const isReadonly = !!voucherId;

              return (
                <Row
                  gutter={[2, 2]}
                  key={key}
                  style={{
                    marginBottom: 1,
                    alignItems: 'center',
                    backgroundColor: key % 2 === 0 ? '#fff' : '#f5f5f5',
                    borderBottom: '1px solid #e8e8e8',
                  }}
                >
                  <Col xs={4}>
                    <Form.Item
                      {...restField}
                      name={[name, 'Value']}
                      rules={[{ required: !isReadonly, message: 'القيمة مطلوبة' }]}
                      style={{ marginBottom: 0 }}
                    >
                      <InputNumber min={0} placeholder="القيمة" style={{ width: '100%' }} readOnly={isReadonly} />
                    </Form.Item>
                  </Col>
                  <Col xs={5}>
                    <Form.Item
                      {...restField}
                      name={[name, 'Date']}
                      rules={[{ required: !isReadonly, message: 'التاريخ مطلوب' }]}
                      style={{ marginBottom: 0 }}
                    >
                      <DatePicker style={{ width: '100%' }} disabled={isReadonly} />
                    </Form.Item>
                  </Col>
                  <Col xs={4}>
                    <Form.Item
                      {...restField}
                      name={[name, 'Currency']}
                      rules={[{ required: !isReadonly, message: 'العملة مطلوبة' }]}
                      style={{ marginBottom: 0 }}
                    >
                      <Select placeholder="العملة" disabled={isReadonly}>
                        {currencies.map((c) => (
                          <Option key={c.x} value={c.x}>
                            {c.sympol || c.Sympol || c.symbol || c.Symbol || c.x}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={7}>
                    <Form.Item
                      {...restField}
                      name={[name, 'Notes']}
                      style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="ملاحظات" readOnly={isReadonly} />
                    </Form.Item>
                  </Col>
                  <Col xs={4}>
                    <Button
                      type="dashed"
                      onClick={() => remove(name)}
                      icon={<MinusCircleOutlined />}
                      danger
                      size="small"
                    >
                    </Button>
                  </Col>
                </Row>
              );
            })}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add({ Currency: 1, Date: dayjs() })}
                icon={<PlusOutlined />}
              >
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </div>
  );
};

export default InvoiceVouchers;
